<div>
  <div class="flex items-center mb-lg border-b border-neutral-200">
    <div class="flex py-lg items-center">
      <span class="text-lg font-semibold text-neutral-900 pe-lg">{{
        'workflow_permission_details_assignee_list_screen_sub_title' | transloco
      }}</span>
      <lib-badge
        [label]="totalAssigneeCount()"
        [badgeClass]="
          'px-sm border-none text-sm font-medium bg-primary-50 text-primary-700'
        " />
    </div>
  </div>
  <div class="py-lg flex flex-col justify-between table-section">
    <lib-table
      [tableClass]="'min-h-[calc(100vh-32rem)] h-full w-full whitespace-nowrap'"
      [id]="'users'"
      [dataSource]="tableData()"
      [loading]="isLoading()"
      [columns]="columns"
      [noDataTitle]="'table_no_data_title' | transloco"
      [noDataDescription]="'section_no_data_description' | transloco"
      [bodyTemplateRef]="[number, name, steps]"
      [titleBottomBorder]="false">
      <ng-template #number let-row let-i="i">
        {{ (currentPage() - 1) * currentSize() + (i + 1) }}
      </ng-template>

      <ng-template #name let-row>
        <div class="flex items-center gap-md">
          <lib-avatar
            [fullName]="row?.data.name"
            [img]="row?.data.image?.url"
            borderRadius="rounded-full"></lib-avatar>
          <div>
            <span class="text-xs font-medium text-neutral-900">{{
              row?.data.name | truncate: 50
            }}</span>
            <p class="text-xs text-neutral-500">
              {{
                'workflow_details_assignee_table_view_{' +
                  row.assignable_type +
                  '}_label' | transloco
              }}
            </p>
          </div>
        </div>
      </ng-template>
      <ng-template #steps let-row>
        {{ handleTemplateSteps(row?.step_templates) }}
      </ng-template>
    </lib-table>
  </div>
  @if (tableData().length) {
    <div class="py-sm">
      <lib-paginator
        class="mt-4xl"
        [sizeOptionsLabel]="
          'pagination_number_of_rows_per_page_label' | transloco
        "
        [nextBtnLabel]="'pagination_next_button_label' | transloco"
        [previousBtnLabel]="'pagination_previous_button_label' | transloco"
        [currentPage]="currentPage()"
        [totalPages]="totalPages()"
        [totalItems]="+totalAssigneeCount()"
        [showChangeSize]="true"
        [sizeOptions]="pageSizeOptions"
        (goTo)="handlePagination($event)"
        (next)="handlePagination($event)"
        (previous)="handlePagination($event)"
        (handleChangeSize)="changeSize($event)"
        [currentSize]="currentSize()"></lib-paginator>
    </div>
  }
</div>
